import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './auth/authSlice';
import createApplicationReducer from './createApplicationSlice';
import myApplicationReducer from './myApplicationSlice';
import questionnaireReducer from './questionnaireSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  createApplication: createApplicationReducer,
  myApplication: myApplicationReducer,
  questionnaire: questionnaireReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
